(function () {
  'use strict';

  var root = document.querySelector('[data-ab-pdp]');
  if (!root) return;

  var doc = document;
  var body = doc.body;
  body.classList.add('has-ab-pdp');

  /* ---------------- translations ----------------
     Every string below comes from the theme locale files through
     snippets/agribasket-js-i18n.liquid, so switching language changes the PDP too.
     The literal after each key is the English fallback used if the bridge is missing. */
  var I18N = (window.AgroBucketI18n && window.AgroBucketI18n.strings) || {};
  function tr(key, fallback, vars) {
    var out = typeof I18N[key] === 'string' && I18N[key] ? I18N[key] : fallback;
    if (out == null) out = '';
    if (vars) {
      out = String(out).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
        return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match;
      });
    }
    return out;
  }

  var form = root.querySelector('[data-ab-pdp-form]');
  var variantInput = root.querySelector('[data-ab-pdp-variant-id]');
  var qtyInput = root.querySelector('[data-ab-pdp-qty]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-ab-pdp-variant]'));
  var priceEl = root.querySelector('[data-ab-pdp-price]');
  var compareEl = root.querySelector('[data-ab-pdp-compare]');
  var saveEl = root.querySelector('[data-ab-pdp-save]');
  var unitEl = root.querySelector('[data-ab-pdp-unit]');
  var availabilityEl = root.querySelector('[data-ab-pdp-availability]');
  var addButton = root.querySelector('[data-ab-pdp-add]');
  var buyButton = root.querySelector('[data-ab-pdp-buy-now]');
  var legendValue = root.querySelector('[data-ab-pdp-legend-value]');
  var statusEl = root.querySelector('[data-ab-pdp-status]');
  var liveRegion = root.querySelector('[data-ab-pdp-live]');

  var sticky = doc.querySelector('[data-ab-pdp-sticky]');
  var stickyVariant = sticky ? sticky.querySelector('[data-ab-pdp-sticky-variant]') : null;
  var stickyPrice = sticky ? sticky.querySelector('[data-ab-pdp-sticky-price]') : null;
  var stickyButton = sticky ? sticky.querySelector('[data-ab-pdp-sticky-add]') : null;

  var gallery = root.querySelector('[data-ab-pdp-gallery]');
  var stage = gallery ? gallery.querySelector('[data-ab-pdp-stage]') : null;
  var stageImage = stage ? stage.querySelector('[data-ab-pdp-image]') : null;
  var prevButton = gallery ? gallery.querySelector('[data-ab-pdp-prev]') : null;
  var nextButton = gallery ? gallery.querySelector('[data-ab-pdp-next]') : null;
  var thumbButtons = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-ab-pdp-thumb]')) : [];
  var dotButtons = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-ab-pdp-dot]')) : [];

  var variantImageMap = {};
  var currencyCode = root.getAttribute('data-ab-pdp-currency') || 'INR';

  /* ---------------- helpers ---------------- */

  function money(cents, currency) {
    var value = Number(cents || 0);
    try {
      return new Intl.NumberFormat(doc.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: currency || currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (error) {
      return 'Rs ' + (value / 100).toFixed(2);
    }
  }

  function announce(message) {
    if (liveRegion) liveRegion.textContent = message;
  }

  function setStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function moneyOrEmpty(cents) {
    return Number(cents || 0) > 0 ? money(cents) : '';
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ---------------- variant state ---------------- */

  function tileFor(id) {
    for (var i = 0; i < tiles.length; i += 1) {
      if (tiles[i].getAttribute('data-variant-id') === String(id)) return tiles[i];
    }
    return null;
  }

  function parseImageMap() {
    var source = root.getAttribute('data-ab-pdp-variant-images');
    if (!source) return;
    try {
      var parsed = JSON.parse(source);
      if (parsed && typeof parsed === 'object') variantImageMap = parsed;
    } catch (error) {
      variantImageMap = {};
    }
  }

  function selectVariant(tile, options) {
    if (!tile || tile.disabled) return;
    var opts = options || {};
    var id = tile.getAttribute('data-variant-id');
    var available = tile.getAttribute('data-available') === 'true';
    var price = Number(tile.getAttribute('data-price') || 0);
    var compare = Number(tile.getAttribute('data-compare') || 0);
    var unit = tile.getAttribute('data-unit-price') || '';
    var title = tile.getAttribute('data-variant-title') || '';
    var hasDeal = compare > price;

    if (variantInput) variantInput.value = id;

    for (var i = 0; i < tiles.length; i += 1) {
      var isCurrent = tiles[i] === tile;
      tiles[i].setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      tiles[i].classList.toggle('is-selected', isCurrent);
      var action = tiles[i].querySelector('[data-ab-pdp-variant-action]');
      if (action) {
        action.textContent = isCurrent
          ? tr('product.selected_label', 'Selected')
          : (tiles[i].disabled ? tr('product.sold_out_lower', 'Sold out') : tr('product.select_lower', 'Select'));
      }
    }

    if (legendValue) legendValue.textContent = title;

    if (priceEl) priceEl.textContent = moneyOrEmpty(price) || tr('product.price_unavailable', 'Price unavailable');
    if (compareEl) {
      compareEl.hidden = !hasDeal;
      compareEl.textContent = hasDeal ? money(compare) : '';
    }
    if (saveEl) {
      saveEl.hidden = !hasDeal;
      saveEl.textContent = hasDeal ? tr('listing.save_amount', 'Save {{ amount }}', { amount: money(compare - price) }) : '';
    }
    if (unitEl) {
      unitEl.hidden = !unit;
      unitEl.textContent = unit;
    }
    if (availabilityEl) {
      availabilityEl.textContent = available ? tr('product.in_stock', 'In stock') : tr('product.sold_out', 'Sold out');
      availabilityEl.classList.toggle('is-sold', !available);
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.getAttribute('data-label-add') || tr('product.add_to_cart', 'Add to cart') : addButton.getAttribute('data-label-sold') || tr('product.sold_out', 'Sold out');
    }
    if (buyButton) {
      buyButton.disabled = !available;
      buyButton.textContent = available ? buyButton.getAttribute('data-label-buy') || tr('product.buy_now', 'Buy now') : buyButton.getAttribute('data-label-sold') || tr('product.sold_out', 'Sold out');
    }
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? stickyButton.getAttribute('data-label-add') || tr('product.add_to_cart', 'Add to cart') : stickyButton.getAttribute('data-label-sold') || tr('product.sold_out', 'Sold out');
    }
    if (stickyVariant) stickyVariant.textContent = title;
    if (stickyPrice) stickyPrice.textContent = moneyOrEmpty(price) || tr('product.price_unavailable', 'Price unavailable');

    setStatus('', false);
    announce((available
      ? tr('product.selected', '{{ title }} selected.', { title: title })
      : tr('product.selected_sold_out', '{{ title }} selected. Currently sold out.', { title: title }))
      + ' ' + (moneyOrEmpty(price) || ''));

    if (opts.syncGallery !== false) {
      var imageIndex = variantImageMap[id];
      if (typeof imageIndex === 'number') showImage(imageIndex, false);
    }
  }

  function currentTile() {
    for (var i = 0; i < tiles.length; i += 1) {
      if (tiles[i].getAttribute('aria-pressed') === 'true') return tiles[i];
    }
    return null;
  }

  /* ---------------- gallery ---------------- */

  function showImage(index, focusThumb) {
    if (!stageImage || !thumbButtons.length) return;
    var target = index;
    if (target < 0) target = thumbButtons.length - 1;
    if (target >= thumbButtons.length) target = 0;

    var button = thumbButtons[target];
    stageImage.src = button.getAttribute('data-image-src');
    stageImage.alt = button.getAttribute('data-image-alt') || '';
    if (button.getAttribute('data-image-srcset')) stageImage.srcset = button.getAttribute('data-image-srcset');

    for (var i = 0; i < thumbButtons.length; i += 1) {
      var active = i === target;
      thumbButtons[i].setAttribute('aria-current', active ? 'true' : 'false');
      if (dotButtons[i]) dotButtons[i].setAttribute('aria-current', active ? 'true' : 'false');
    }

    if (focusThumb === true) button.focus();
    announce(tr('product.showing_image', 'Showing image {{ index }} of {{ total }}', {
      index: target + 1,
      total: thumbButtons.length
    }));
  }

  function activeImageIndex() {
    for (var i = 0; i < thumbButtons.length; i += 1) {
      if (thumbButtons[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function variantImageIndexFor(id) {
    var value = variantImageMap[String(id)];
    return typeof value === 'number' ? value : null;
  }

  parseImageMap();

  for (var t = 0; t < tiles.length; t += 1) {
    tiles[t].addEventListener('click', function (event) {
      selectVariant(event.currentTarget);
    });
  }

  if (thumbButtons.length) {
    thumbButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showImage(index, false);
      });
    });
    dotButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showImage(index, false);
      });
    });
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        showImage(activeImageIndex() - 1, false);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showImage(activeImageIndex() + 1, false);
      });
    }
    if (stage) {
      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showImage(activeImageIndex() - 1, false);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(activeImageIndex() + 1, false);
        }
      });
    }
  }

  /* ---------------- sticky mobile bar ---------------- */

  /* The bar is CSS-positioned above the fixed mobile dock (bottom: var(--dock));
     JS only toggles visibility and the matching page padding. */
  function syncSticky() {
    if (!sticky) return;
    var mobile = window.matchMedia ? window.matchMedia('(max-width: 749px)').matches : window.innerWidth <= 749;
    if (!mobile) {
      sticky.setAttribute('hidden', '');
      sticky.removeAttribute('open');
      root.classList.remove('has-pdp-sticky');
      return;
    }
    sticky.removeAttribute('hidden');
    root.classList.add('has-pdp-sticky');
  }

  function scrollToAddButton() {
    if (!addButton || typeof addButton.scrollIntoView !== 'function') return;
    try {
      addButton.scrollIntoView({ block: 'center', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    } catch (error) {
      addButton.scrollIntoView();
    }
  }

  if (sticky) {
    sticky.addEventListener('click', function (event) {
      var trigger = event.target;
      if (!trigger || typeof trigger.closest !== 'function') return;
      if (!trigger.closest('[data-ab-pdp-sticky-add]')) return;
      event.preventDefault();
      var tile = currentTile();
      if (!tile || tile.getAttribute('data-available') !== 'true') {
        setStatus(tr('product.variant_sold_out', 'This variant is currently sold out.'), true);
        return;
      }
      if (addButton && typeof addButton.click === 'function') {
        addButton.click();
        scrollToAddButton();
      }
    });
  }

  /* ---------------- add to cart ---------------- */

  function postForm(url, formData) {
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      /* Buy Now now carries the submitter's `checkout` flag, so the server can
         answer with a redirect to checkout instead of JSON. Read the body as
         text and parse opportunistically so that response still reads as ok. */
      return response.text().then(function (body) {
        var data = null;
        if (body) {
          try { data = JSON.parse(body); } catch (error) { data = null; }
        }
        return {
          ok: response.ok,
          status: response.status,
          data: data,
          redirected: response.redirected === true,
          url: response.url || ''
        };
      });
    });
  }

  function buildFormData(targetForm, submitter) {
    /* FormData(form, submitter) carries the pressed button's name/value, which is
       how Shopify receives the Buy Now `checkout` flag. Browsers that ignore the
       second argument, or a submitter outside the form, fall back to appending. */
    if (!submitter) return new FormData(targetForm);
    var formData;
    try {
      formData = new FormData(targetForm, submitter);
    } catch (error) {
      formData = new FormData(targetForm);
    }
    if (submitter.name) {
      var included = typeof formData.has === 'function' ? formData.has(submitter.name) : true;
      if (!included) formData.append(submitter.name, submitter.value || '');
    }
    return formData;
  }

  function headerCartBadge() {
    var host = doc.querySelector('.ab-cart');
    if (!host) return null;
    var badge = host.querySelector(':scope > i');
    if (!badge) {
      badge = doc.createElement('i');
      badge.setAttribute('aria-hidden', 'true');
      host.appendChild(badge);
    }
    return badge;
  }

  function paintHeaderCartCount(count) {
    var host = doc.querySelector('.ab-cart');
    var badge = headerCartBadge();
    if (!host || !badge) return;
    var total = Number(count) || 0;
    badge.textContent = total > 0 ? String(total) : '';
    host.setAttribute('aria-label', total > 0
      ? tr('nav.cart_count', 'Cart, {{ count }} items', { count: total })
      : tr('nav.cart', 'Cart'));
    if (total > 0) host.setAttribute('data-ab-cart-filled', '');
    else host.removeAttribute('data-ab-cart-filled');
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then(function (cart) {
        var count = Number(cart && cart.item_count) || 0;
        paintHeaderCartCount(count);
        return count;
      });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      var tile = currentTile();
      var available = variantInput && tile && tile.getAttribute('data-available') === 'true';
      if (!available) {
        /* Let the native form post run and surface the server error. */
        return;
      }
      if (!window.fetch || typeof FormData !== 'function') return;

      var submitter = event.submitter || null;
      var isBuyNow = !!(submitter && submitter.hasAttribute('data-ab-pdp-buy-now'));
      event.preventDefault();

      var formData = buildFormData(form, submitter);
      if (qtyInput && Number(qtyInput.value) < 1) qtyInput.value = '1';
      formData.set('quantity', qtyInput ? qtyInput.value : '1');

      var busyLabel = isBuyNow
        ? tr('product.adding_opening_cart', 'Adding and opening your cart\u2026')
        : tr('product.adding', 'Adding\u2026');
      if (addButton) addButton.disabled = true;
      if (buyButton) buyButton.disabled = true;
      setStatus(busyLabel, false);

      var endpoint = (form.getAttribute('action') || '/cart/add').replace(/\/$/, '') + '.js';

      postForm(endpoint, formData)
        .then(function (result) {
          var data = result.data || {};
          if (!result.ok || result.status >= 400 || data.status) {
            throw new Error(data.description || data.message || tr('product.add_failed', 'This item could not be added right now.'));
          }
          refreshCartCount()
            .then(function (count) {
              var detail = { item_count: count };
              announce(tr('product.added_to_cart', 'Added to cart.'));
              doc.dispatchEvent(new CustomEvent('ab:cart:updated', { detail: detail }));
              doc.dispatchEvent(new CustomEvent('shopify:cart:updated', { detail: detail }));
              if (isBuyNow) {
                setStatus(tr('product.added_opening_cart', 'Added to cart. Opening your cart\u2026'), false);
                window.location.href = form.getAttribute('data-ab-cart-url') || '/cart';
              } else {
                setStatus(tr('product.added_count', 'Added to cart. {{ count }} item(s) in your cart.', { count: count }), false);
              }
            })
            .catch(function () {
              announce(tr('product.added_to_cart', 'Added to cart.'));
              if (isBuyNow) window.location.href = form.getAttribute('data-ab-cart-url') || '/cart';
              else setStatus(tr('product.added_to_cart', 'Added to cart.'), false);
            });
        })
        .catch(function (error) {
          setStatus(error && error.message ? error.message : tr('product.add_failed', 'This item could not be added right now.'), true);
          announce(tr('product.add_failed', 'Add to cart failed.'));
        })
        .then(function () {
          var tile = currentTile();
          var available = tile && tile.getAttribute('data-available') === 'true';
          if (addButton) addButton.disabled = !available;
          if (buyButton) buyButton.disabled = !available;
        });
    });
  }

  /* ---------------- pincode: format check only ---------------- */

  var pincodeForm = root.querySelector('[data-ab-pdp-pincode-form]');
  var pincodeInput = root.querySelector('[data-ab-pdp-pincode]');
  var pincodeStatus = root.querySelector('[data-ab-pdp-pincode-status]');

  function setPincodeStatus(message, tone) {
    if (!pincodeStatus) return;
    pincodeStatus.textContent = message || '';
    pincodeStatus.classList.remove('is-error', 'is-ok');
    if (tone === 'error') pincodeStatus.classList.add('is-error');
    if (tone === 'ok') pincodeStatus.classList.add('is-ok');
  }

  if (pincodeInput) {
    pincodeInput.addEventListener('input', function () {
      var cleaned = pincodeInput.value.replace(/[^0-9]/g, '').slice(0, 6);
      if (cleaned !== pincodeInput.value) pincodeInput.value = cleaned;
    });
  }

  if (pincodeForm && pincodeInput) {
    pincodeForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = pincodeInput.value.trim();
      if (!/^[0-9]{6}$/.test(value)) {
        pincodeInput.setCustomValidity(tr('product.pincode_invalid', 'Enter a 6 digit Indian pincode'));
        setPincodeStatus(tr('product.pincode_invalid', 'Enter a 6 digit Indian pincode.'), 'error');
        if (typeof pincodeInput.reportValidity === 'function') pincodeInput.reportValidity();
        announce(tr('product.pincode_invalid', 'Enter a 6 digit Indian pincode.'));
        return;
      }
      pincodeInput.setCustomValidity('');
      setPincodeStatus(tr('product.pincode_ok', 'Pincode format looks correct. Delivery dates, charges and serviceability are confirmed at checkout.'), 'ok');
      announce(tr('product.pincode_ok_announce', 'Pincode format accepted. Delivery details are confirmed at checkout.'));
    });
    pincodeInput.addEventListener('blur', function () {
      var value = pincodeInput.value.trim();
      if (value === '' || /^[0-9]{6}$/.test(value)) pincodeInput.setCustomValidity('');
    });
  }

  /* ---------------- bulk / bulk-enquiry context for the shared contact sheet ---------------- */

  function contactContext() {
    var tile = currentTile();
    var variantTitle = tile ? tile.getAttribute('data-variant-title') || '' : '';
    var handle = root.getAttribute('data-ab-pdp-handle') || '';
    var parts = [];
    var title = root.getAttribute('data-ab-pdp-title') || '';
    if (title) parts.push('Bulk enquiry for ' + title);
    if (variantTitle) parts.push('variant: ' + variantTitle);
    if (handle) parts.push(window.location.origin + '/products/' + handle);
    return parts.join(' | ');
  }

  var bulkButtons = root.querySelectorAll('[data-ab-pdp-bulk]');
  for (var b = 0; b < bulkButtons.length; b += 1) {
    bulkButtons[b].setAttribute('data-ab-contact-context', contactContext());
    bulkButtons[b].addEventListener('mouseenter', function (event) {
      event.currentTarget.setAttribute('data-ab-contact-context', contactContext());
    });
    bulkButtons[b].addEventListener('focus', function (event) {
      event.currentTarget.setAttribute('data-ab-contact-context', contactContext());
    });
    bulkButtons[b].addEventListener('click', function (event) {
      event.currentTarget.setAttribute('data-ab-contact-context', contactContext());
    });
  }

  /* ---------------- wishlist (same storage key as the rest of the storefront) ---------------- */

  var wishButton = root.querySelector('[data-ab-pdp-wishlist]');
  if (wishButton) {
    var WISHLIST_KEY = 'agribasket-wishlist';
    var handle = wishButton.getAttribute('data-ab-pdp-wishlist') || root.getAttribute('data-ab-pdp-handle');
    var wishText = wishButton.querySelector('[data-ab-pdp-wishlist-text]');
    var wishIcon = wishButton.querySelector('[data-ab-pdp-wishlist-icon]');
    var productTitle = wishButton.getAttribute('data-ab-pdp-title') || tr('product.this_product', 'this product');

    var readWishlist = function () {
      try {
        var value = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(value) ? value.filter(function (item) { return typeof item === 'string' && item.trim(); }) : [];
      } catch (error) {
        return [];
      }
    };

    var writeWishlist = function (value) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(value)); } catch (error) {}
    };

    var paintWishlist = function (active) {
      wishButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      wishButton.classList.toggle('is-saved', active);
      if (wishIcon) wishIcon.textContent = active ? '\u2665' : '\u2661';
      if (wishText) wishText.textContent = active ? tr('product.saved_wishlist', 'Saved to wishlist') : tr('product.save_wishlist', 'Save to wishlist');
      wishButton.setAttribute('aria-label', active
        ? tr('product.remove_label', 'Remove {{ title }} from wishlist', { title: productTitle })
        : tr('product.save_label', 'Save {{ title }} to wishlist', { title: productTitle }));
    };

    var syncWishlist = function () {
      paintWishlist(handle ? readWishlist().indexOf(handle) > -1 : false);
    };

    syncWishlist();
    window.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) syncWishlist();
    });
    /* The listing cards publish the same change on the document, so this button
       stays truthful when the same product is toggled from another card. */
    doc.addEventListener('agribasket:wishlist-change', function () { syncWishlist(); });

    wishButton.addEventListener('click', function () {
      if (!handle) return;
      var saved = readWishlist();
      var index = saved.indexOf(handle);
      var active = index < 0;
      if (active) saved.push(handle);
      else saved.splice(index, 1);
      writeWishlist(saved);
      paintWishlist(active);
      announce(active
        ? tr('product.save_wishlist_announce', 'Saved to wishlist.')
        : tr('product.remove_wishlist_announce', 'Removed from wishlist.'));
      doc.dispatchEvent(new CustomEvent('agribasket:wishlist-change', {
        detail: { handle: handle, saved: saved.slice(), active: active }
      }));
    });
  }

  /* ---------------- initial paint ---------------- */

  /* Steer the server-rendered gallery to the selected variant's image once, so
     Liquid and JS agree on the starting slide. */
  if (variantInput && thumbButtons.length) {
    var initialIndex = variantImageIndexFor(variantInput.value);
    if (typeof initialIndex === 'number') showImage(initialIndex, false);
  }

  var initialTile = currentTile();
  if (initialTile) {
    /* Re-apply the selected variant so the sticky bar, price and buttons always
       match the server-rendered selection. Gallery sync is skipped here because
       the stage already shows the correct image. */
    selectVariant(initialTile, { syncGallery: false });
  }

  syncSticky();
  if (sticky) {
    window.addEventListener('resize', syncSticky);
    if (window.matchMedia) {
      var stickyQuery = window.matchMedia('(max-width: 749px)');
      if (typeof stickyQuery.addEventListener === 'function') stickyQuery.addEventListener('change', syncSticky);
      else if (typeof stickyQuery.addListener === 'function') stickyQuery.addListener(syncSticky);
    }
  }
})();
